<template>
	<div
		class="menu-container"
		:style="showMenu ? 'pointer-events: all' : ''"
		@mouseleave="(rotating = false), (scaling = false)"
		@mouseup="(rotating = false), (scaling = false)"
		@mousemove="mouseMoveHandler"
	>
		<transition
			name="bounce"
			@after-enter="animated"
			@after-leave="animated"
			:style="`i:${areaWidthRatio}`"
		>
			<div
				v-show="showMenu"
				id="menu"
				class="menu"
				:style="{
					left: menuX - scaleComp + 'px',
					top: menuY - scaleComp + 'px',
					width: 60 + 'px',
					height: 60 + 'px',
					transform: `scale(${areaWidthRatio})`
				}"
			>
				<div
					v-if="!item.type"
					@mousedown.stop="editItem(item)"
					class="menu-button"
					:class="getItemType(item)"
					:style="{
						height: 20 + 'px',
						width: 20 + 'px',
						left: 20 + 'px',
						top: 20 - 30 * menuScale + 'px'
					}"
				/>
				<div
  v-for="(groupItem, index) in item.items"
  :key="groupItem.id"
  v-if="!someCondition"
  @mousedown.left.stop="editItem(groupItem)"
  @mousedown.right.stop="ungroup(groupItem, index)"
  class="menu-button"
  :class="getItemType(groupItem)"
  :style="{
    height: '20px',
    width: '20px',
    left: getX(groupItem, index) + 20 + 'px',
    top: getY(groupItem, index) + 20 + 'px'
  }"
></div>
				<div
					class="svg-container"
					:style="{
						position: 'absolute',
						height: 100 + 'px',
						width: 100 + 'px',
						left: -20 + 'px',
						top: -20 + 'px'
					}"
				>
					<svg :width="100" :height="100">
						<!-- Menu circle -->
						<circle
							:cx="50"
							:cy="50"
							:r="28 * menuScale || 30"
							stroke="lightgrey"
							:stroke-width="2"
							fill="transparent"
						/>
						<!-- Close button -->
						<g v-show="!rotating && !scaling">
							<circle
								@mousedown.stop="toggleMenu"
								class="circle-button"
								:cx="50"
								:cy="50"
								:r="10"
								stroke="lightgrey"
								:stroke-width="1"
								fill="white"
							/>
							<polygon
								:points="`${45},${45} ${55},${55}`"
								class="cross"
								:style="{ 'stroke-width': 1 }"
							/>
							<polygon
								:points="`${55},${45} ${45},${55}`"
								class="cross"
								:style="{ 'stroke-width': 1 }"
							/>
						</g>
						<g v-if="!item.type">
							<!-- Rotation slider -->
							<g
								:transform="`translate(${48 + 30 * menuScale}, 0)`"
								v-if="!isMobile"
							>
								<line
									:x1="0"
									:y1="25"
									:x2="0"
									:y2="75"
									style="stroke: lightgrey; stroke-width: 1"
								/>
								<circle
									@mousedown="rotating = true"
									@contextmenu.prevent="resetRot"
									class="circle-button"
									:cx="0"
									:cy="50 + rotatePos"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<g :transform="`translate(0,${rotatePos / 1})`">
									<circle
										:cx="0"
										:cy="50"
										:r="4"
										stroke="black"
										:stroke-width="1"
										fill="transparent"
									/>
									<line
										:x1="-5"
										:x2="5"
										:y1="50"
										:y2="50"
										stroke="white"
										:stroke-width="2"
									/>
									<polygon points="1 48.5, 4.5 46, 4.5 50" />
									<polygon points="-1 51.5, -4.5 54, -4.5 50" />
								</g>
							</g>
							<!-- Rotation buttons -->
							<g
								:transform="`translate(${48 + 30 * menuScale}, 0)`"
								v-if="isMobile"
							>
								<circle
									@click="rotate(-45)"
									class="circle-button"
									:cx="-2"
									:cy="40"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<g>
									<circle
										:cx="-2"
										:cy="40"
										:r="4"
										stroke="black"
										:stroke-width="1"
										fill="transparent"
									/>
									<line
										:x1="-6.5"
										:x2="-2"
										:y1="37"
										:y2="45.5"
										stroke="white"
										:stroke-width="5"
									/>
									<polygon points="-2.2 38, -6 38.2, -4.5 34.5" />
								</g>
								<circle
									@click="rotate(45)"
									class="circle-button"
									:cx="-2"
									:cy="60"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<g>
									<circle
										:cx="-2"
										:cy="60"
										:r="4"
										stroke="black"
										:stroke-width="1"
										fill="transparent"
									/>
									<line
										:x1="-6.5"
										:x2="-2"
										:y1="63"
										:y2="54.5"
										stroke="white"
										:stroke-width="5"
									/>
									<polygon points="-2.2 62, -6 61.8, -4.5 65.5" />
								</g>
							</g>
							<!-- Size slider -->
							<g
								:transform="`translate(${52 - 30 * menuScale}, 0)`"
								v-if="!isMobile"
							>
								<line
									x1="0"
									y1="25"
									x2="0"
									y2="75"
									style="stroke: lightgrey; stroke-width: 1"
								/>
								<circle
									@mousedown="scaling = true"
									@contextmenu.prevent="resetScale"
									class="circle-button"
									:cx="0"
									:cy="50 + scalePos"
									:r="6"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<line
									x1="-4"
									y1="20"
									x2="4"
									y2="20"
									style="stroke: black; stroke-width: 1"
								/>
								<line
									x1="0"
									y1="16"
									x2="0"
									y2="24"
									style="stroke: black; stroke-width: 1"
								/>
								<line
									x1="-4"
									y1="80"
									x2="4"
									y2="80"
									style="stroke: black; stroke-width: 1"
								/>
							</g>
							<!-- Size buttons -->
							<g
								:transform="`translate(${52 - 30 * menuScale}, 0)`"
								v-if="isMobile"
							>
								<circle
									@click="scale(0.1)"
									class="circle-button"
									:cx="2"
									:cy="40"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<circle
									@click="scale(-0.1)"
									class="circle-button"
									:cx="2"
									:cy="60"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<line
									x1="-2"
									y1="40"
									x2="6"
									y2="40"
									style="stroke: black; stroke-width: 1"
								/>
								<line
									x1="2"
									y1="36"
									x2="2"
									y2="44"
									style="stroke: black; stroke-width: 1"
								/>
								<line
									x1="-2"
									y1="60"
									x2="6"
									y2="60"
									style="stroke: black; stroke-width: 1"
								/>
							</g>
							<!-- Reset button -->
							<g
								:transform="
									`translate(${45 + 15 * menuScale}, ${51 + 25 * menuScale})`
								"
							>
								<circle
									@click.stop="resetItem"
									class="circle-button"
									:cx="0"
									:cy="0"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<g :transform="`scale(-1, 1)`">
									<circle
										:cx="0"
										:cy="0"
										:r="4"
										stroke="black"
										:stroke-width="1"
										fill="transparent"
									/>
									<line
										:x1="0"
										:x2="5"
										:y1="0"
										:y2="0"
										stroke="white"
										:stroke-width="3"
									/>
									<polygon points="1 -1.5, 4.5 -4, 4.5 0" />
								</g>
							</g>
							<!-- Accept button -->
							<g
								:transform="
									`translate(${55 - 15 * menuScale}, ${51 + 25 * menuScale})`
								"
							>
								<circle
									@click.stop="saveItem"
									class="circle-button"
									:cx="0"
									:cy="0"
									:r="7"
									stroke="lightgrey"
									:stroke-width="1"
									fill="white"
								/>
								<line
									x1="4"
									y1="-2"
									x2="-1"
									y2="3"
									style="stroke: black; stroke-width: 1"
								/>
								<line
									x1="-1"
									y1="3"
									x2="-3.5"
									y2="0.5"
									style="stroke: black; stroke-width: 1"
								/>
							</g>
						</g>
					</svg>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import iconMixin from '@/mixins/iconMixin.js';
export default {
	mixins: [iconMixin],
	model: {
		prop: 'showMenu',
		event: 'menuStatus'
	},
	props: {
		showMenu: Boolean,
		menuX: Number,
		menuY: Number,
		item: Object,
		zoomLevel: Number,
		areaWidthRatio: Number
	},
	data: () => ({
		rotating: false,
		scaling: false,
		rotatePos: 0,
		scalePos: 0,
		scaleComp: 0,
		backupItem: {}
	}),
	watch: {
		item() {
			if (this.backupItem.id !== this.item.id) {
				this.backupItem = { ...this.item };
			}

			this.resetMenu();
		},
		rotating(to) {
			this.$emit('sliders', to);
		},
		scaling(to) {
			this.$emit('sliders', to);
		},
		showMenu(to) {
			if (to) {
				this.resetMenu();
			}
		}
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		itemScale() {
			const scale = this.item.scale || 1;

			return scale < 0.3 ? 0.3 : scale;
		},
		menuScale() {
			const scale = this.item.scale || 1;

			return scale < 0.8 ? 0.8 : scale;
		}
	},
	methods: {
		toggleMenu() {
			if (!this.rotating && !this.scaling) {
				this.resetItem();
				this.closeMenu();
			}
		},
		resetMenu() {
			let scaleMultiplier = this.item.scale < 1 ? 1.5 : 2;
			const sliderLimit = 20;
			const lowerScaleLimit = 0.3;
			this.scalePos = this.item.scale < lowerScaleLimit ? 0 : -(this.item.scale - 1) * (sliderLimit * scaleMultiplier);
			let deg = this.item.rotation;
			deg = deg > 180 ? -(deg - 180) : deg;
			this.rotatePos = deg / 9;
			this.scaleComp = 30 - 15 * this.areaWidthRatio * this.item.scale;
		},
		closeMenu() {
			this.$emit('menuStatus', false);
			this.backupItem.id = -1;
		},
		animated() {
			this.$emit('animated');
		},
		mouseMoveHandler(ev) {
			const sliderLimit = 20;
			
			if (this.rotating) {
				this.rotatePos += ev.movementY / this.zoomLevel;
				this.rotatePos = this.rotatePos < -sliderLimit
					? -sliderLimit
					: this.rotatePos > sliderLimit
						? sliderLimit
						: this.rotatePos;
				this.item.rotation = Math.floor(
					this.rotatePos < 0 ? 360 + this.rotatePos * 9 : this.rotatePos * 9
				);
			} else if (this.scaling) {
				this.scalePos += ev.movementY / this.zoomLevel;
				this.scalePos =
								this.scalePos < -sliderLimit ? -sliderLimit : this.scalePos > sliderLimit ? sliderLimit : this.scalePos;
					
				let scaleMultiplier = this.scalePos > 0 ? 1.5 : 2;
				let scale = this.scalePos / (sliderLimit * scaleMultiplier);
				this.item.scale = 1 - scale;
			}
		},
		resetRot() {
			this.rotatePos = 0;
			this.item.rotation = 0;
		},
		rotate(deg) {
			this.item.rotation = this.item.rotation + deg;
		},
		resetScale() {
			this.scalePos = 0;
			this.item.scale = 1;
		},
		scale(scale) {
			if (!this.item.scale) {
				this.item.scale = 1;
			}

			this.item.scale = this.item.scale + scale;

			if (this.item.scale < 0.3) {
				this.item.scale = 0.3;
			}

			if (this.item.scale > 1.5) {
				this.item.scale = 1.5;
			}
		},
		saveItem() {
			this.$emit('saveItem', this.item);
			this.closeMenu();
		},
		resetItem() {
			this.item.scale = this.backupItem.scale;
			this.item.rotation = this.backupItem.rotation;
		},
		editItem(item) {
			this.$emit('editItem', item);
		},
		ungroup(item, index) {
			let r = 28 * this.item.scale || 30;
			const length = this.item.items.length;
			let deg = ((2 * Math.PI) / length) * (index + 1) - (2 * Math.PI) / 4;
			item.positionX = this.item.positionX + parseInt(r * Math.cos(deg) * 2);
			item.positionY = this.item.positionY - parseInt(r * Math.sin(deg) * 3);
			this.$emit('saveItem', item);
			this.closeMenu();
		},
		getX(item, index) {
			let r = 28 * this.menuScale || 30;
			const length = this.item.items.length;
			let deg = ((2 * Math.PI) / length) * (index + 1) - (2 * Math.PI) / 4;

			return r * Math.cos(deg);
		},
		getY(item, index) {
			let r = 28 * this.menuScale || 30;
			const length = this.item.items.length;
			let deg = ((2 * Math.PI) / length) * (index + 1) - (2 * Math.PI) / 4;

			return r * Math.sin(deg);
		},
		getItemType(item) {
			let type = '';

			if (!item.id) return;

			if (!item.fireProtection && !item.type) return;

			if (item.type === 'Grupp')
				type = item.items[0].fireProtection.inventoryType;
			else type = item.fireProtection.inventoryType;

			return this.getType(type)?.icon;
		}
	}
};
</script>

<style lang="scss" scoped>
.menu-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}
.menu {
  z-index: 2;
  position: absolute;
  pointer-events: none;
  .circle-button {
    cursor: pointer;
  }
  .menu-button {
    pointer-events: all;
  }
  .cross {
    stroke: black;
    pointer-events: none;
  }
  .svg-container {
    pointer-events: none;
    svg circle.circle-button {
      pointer-events: all;
    }
  }
}
.menu-button {
  background-color: transparent;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  background-size: contain;
}
</style>
